<template>
    <div v-loading="loading" element-loading-text="查询中..." ref="roleList">
        <div v-if="com.comRoles != null && com.comRoles.length > 0" v-for="com in comList">
            <div style="margin: 10px 0;" class="content-caption dashed">
                <span><span class="color-laber"></span>{{com.name}}</span>
            </div>
            <ul class="switch-list clearfix ml10">
                <el-checkbox-group v-model="checkedRoles">
                    <el-checkbox v-for="role in com.comRoles" :label="role.id">
                        <span><i class="icon iconfont icon-wujiaoxingman mr5" style="color: #eaea0f;"></i>{{role.name}}</span>
                    </el-checkbox>
                </el-checkbox-group>
            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    import servicerAuthxApi from '../../api/servicerAuthx'

    export default {
        name: 'swb-role-list',
        desc: '岗位列表',
        props: ['staff'],
        data: function () {
            return {
                loading: false,
                comList: [],
                checkedRoles: []
            }
        },
        created: function () {
            if(Utils.isNoB(this.staff)) {
                this.$message.error("请指定员工！");
            } else {
                this.loading = true;
                this.getServicerComRoleList();
                this.getStaffRoleList(this.staff.id);
            }
        },
        methods: {
            getServicerComRoleList: function () {
                let self = this;
                let postData = {};
                postData.bizUnitId = this.staff.comId;
                servicerAuthxApi.getServicerComRoleListByBizUnitId(postData, function (result) {
                    if(result.type === "info") {
                        self.comList = result.data;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getStaffRoleList: function (staffId) {
                let self = this;
                servicerAuthxApi.getServicerStaffRoleList({staffId: staffId, comId: this.staff.comId}, function (result) {
                    self.loading = false;
                    if(result.type === "info") {
                        for(let i = 0; i < result.data.length; i++) {
                            let data = result.data[i];
                            self.checkedRoles.push(data.roleId);
                        }
                        //
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.data = self.checkedRoles;
                return result;
            }
        },
    }
</script>





// WEBPACK FOOTER //
// src/compo/authx/RoleList.vue